import { Button, Result, Space, Spin, Typography } from 'antd';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';


const { Text, Title } = Typography;

const CollectionCreationResultStep = ({ createCollectionStatus, goToPreviousStep, latestCreatedCollectionId }) => {

    const history = useHistory();

    if(createCollectionStatus === "NOT ATTEMPTED") {
        return <div style={{textAlign: "center"}}>
             <Title level={3}>Waiting to publish your collection...</Title>
        </div>
    } else if(createCollectionStatus === "LOADING") {
        return <div style={{textAlign: "center"}}>
            <Space><Spin size="large" />
            <Title level={3}>Publishing your collection...</Title>
            </Space>
        </div>
    } else if(createCollectionStatus === "SUCCESS"){
        return <div style={{textAlign: "center"}}>
            <Result
                status="success"
                title="Your collection is now available!"
                subTitle="Click the button below to find links to share your collection."
                extra={[
                    <Button
                        type="primary"
                        onClick={()=>history.push(`/creator/created-collections/${latestCreatedCollectionId}`)}
                    >
                        View your collection
                    </Button>,
                ]}
            />
            
        </div>
    } else if(createCollectionStatus === "FAILED"){
        return <div style={{textAlign: "center"}}>
            <Result
                status="error"
                title="Submission Failed"
                subTitle="Something went wrong with creating your collection."
                extra={[
                    <Button onClick={()=>{ goToPreviousStep()}}>Go Back</Button>,
                ]}
            />
        </div>
    }
    return 
}
const mapStateToProps = state => {
    return {
        createCollectionStatus: state.contentCreationReducer.createCollectionStatus,
        latestCreatedCollectionId: state.contentCreationReducer.latestCreatedCollectionId
    }
}
export default connect(mapStateToProps, { })(CollectionCreationResultStep);